import Vue from 'vue';
import Vuetify from 'vuetify';
import ru from 'vuetify/src/locale/ru';

Vue.use(Vuetify);

const opts = {
    theme: {
        themes: {
            light: {
                primary: '#26292B',
                secondary: '#9B9BC7',
                accent: '#6E258B',
                error: '#FF4B3A',
                success: '#37AB00',
            },
        },
    },
    lang: {
        locales: { ru },
        current: 'ru',
    },
};

export default new Vuetify(opts);
